export const URL_GET_ALL_TARIFF = "https://unbloke.ru:3456/tariff/all";
export const URL_CREATE_SUBSCRITION = "https://unbloke.ru:3456/subscription/create";
export const URL_CONFIRM_SUBSCRITION = "https://unbloke.ru:3456/subscription/confirm";
export const URL_PROMO_CODE_VALIDATION = "https://unbloke.ru:3456/promo_code/validation?code=";